import { AccessControlCheck } from 'components/accessControl/AccessControlCheck';
import { ExternalCommentsContainer } from 'components/order/comments/ExternalCommentsContainer';
import React from 'react';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';

export const ExternalCommentsPage: React.FC = () => {
  return (
    <AccessControlCheck allowedPermissions={[ePermissions.CommentsRead]}>
      <ExternalCommentsContainer />
    </AccessControlCheck>
  );
};
